const PURINA_URLS = {
    dev: 'https://dev-h20.purina.com',
    qa: 'https://test-h20.purina.com',
    prod: 'https://www.purina.com'
};
const getPurinaUrl = (url)=>{
    if ([
        'dev-myprofile.purina.com',
        'localhost'
    ].some((sub)=>url.includes(sub))) return PURINA_URLS['dev'];
    if (url.includes('stage-myprofile.purina.com')) return PURINA_URLS['qa'];
    return PURINA_URLS['prod'];
};
const API_URLS = {
    dev: 'https://api.services-dev.purina.com',
    qa: 'https://api.services-qa.purina.com',
    prod: 'https://api.services.purina.com'
};
const getApiUrl = (oAuthDomain)=>{
    if ([
        'login-dev.purina.com',
        'auth-dev.purina.com'
    ].includes(oAuthDomain)) return API_URLS['dev'];
    if ([
        'login-ts.purina.com',
        'auth-ts.purina.com'
    ].includes(oAuthDomain)) return API_URLS['qa'];
    return API_URLS['prod'];
};
const toLowerParams = (params)=>{
    if (!params) return {};
    const entries = Object.entries(params);
    const newObj = {};
    entries.forEach((entry)=>{
        if ('string' == typeof entry[1]) newObj[entry[0]] = entry[1].toLowerCase();
        else newObj[entry[0]] = '';
    });
    return newObj;
};
const sendIt = ({ event, eventParams, up }, dataLayerName, logging = false)=>{
    const dlname = dataLayerName ?? 'purData';
    if (logging) {
        console.groupCollapsed(`%cGA Event: ${event}`, 'color: #ffb300');
        console.log({
            dataLayerName: dlname,
            event: {
                event,
                eventParams
            }
        });
        console.groupEnd();
    }
    if ('undefined' != typeof window) return window[dlname]?.push({
        event: event?.toLowerCase(),
        event_params: toLowerParams(eventParams),
        up: up ? toLowerParams(up) : void 0
    }, {
        event_params: void 0
    });
};
export { getApiUrl, getPurinaUrl, sendIt };
